import { z } from 'zod';

export const courtSchema = z.object({
  idCourt: z.number(),
  Court: z.string().default(''),
  idFederalState: z.number().default(4),
  FederalState: z.string().default('Brandenburg'),
  Street: z
    .string()
    .nullable() // null ist erlaubt
    .transform(val => val ?? '') // null -> '', sonst Wert behalten
    .default(''),
  StreetNr: z
    .string()
    .nullable() // null ist erlaubt
    .transform(val => val ?? '') // null -> '', sonst Wert behalten
    .default(''),

  Court_Email: z
    .string()
    .nullable() // null ist erlaubt
    .transform(val => val ?? '') // null -> '', sonst Wert behalten
    .default(''),

  activeCourt: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
  StreetAditional: z.string().nullable(),
  XJustizID: z.string().nullable(),
  PhoneNumber: z.string().nullable(),
  Website: z.string().nullable(),

  idPostcode: z.number().nullable(),
  // Aus RElationen
  Postcode: z.string().optional(),
  City: z.string().optional(),
});

export type ICourt = z.infer<typeof courtSchema>;
